import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="footer-logo-horse">HORSE</span>
              <span className="footer-logo-stat">STAT</span>
            </Link>
            <p className="footer-tagline">
              Data-driven horse racing analysis. 22 angles per horse, every race, every day.
            </p>
            <a
              href="https://app.horsestat.com"
              className="footer-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Try HorseStat Free
            </a>
          </div>

          <div className="footer-cols">
            <div className="footer-col">
              <h4>Product</h4>
              <ul>
                <li><Link to="/features#interactive-racecard">Interactive Race Card</Link></li>
                <li><Link to="/features#form-analysis">Form Analysis</Link></li>
                <li><Link to="/features#pace-draw">Pace Analysis &amp; Draw Bias</Link></li>
                <li><Link to="/features#trainer-jockey-owner">Trainer, Jockey &amp; Owner Stats</Link></li>
                <li><Link to="/features#sire-dam">Sire &amp; Dam Performance</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Articles</h4>
              <ul>
                <li><Link to="/help/getting-started/what-is-horsestat">What is HorseStat?</Link></li>
                <li><Link to="/help/getting-started/understanding-the-racecard">Understanding the Racecard</Link></li>
                <li><Link to="/help/getting-started/how-to-analyse-a-race">How to Analyse a Race</Link></li>
                <li><Link to="/help/core-metrics/what-does-prb-mean">PRB Explained</Link></li>
                <li><Link to="/help/core-metrics/what-is-the-horsestat-rating-system">The HorseStat Rating System</Link></li>
                <li><Link to="/help/racing-basics">Horse Racing Basics</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Learn</h4>
              <ul>
                <li><Link to="/help/getting-started">Help Centre</Link></li>
                <li><Link to="/getting-started">Getting Started</Link></li>
                <li><Link to="/help/core-metrics">Core Metrics Explained</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li>
                  <a href="https://app.horsestat.com" target="_blank" rel="noopener noreferrer">
                    Get Started
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Company</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About HorseStat</Link></li>
                <li><Link to="/updates">What&apos;s new</Link></li>
                <li><a href="mailto:contact@horsestat.com">Contact</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 HorseStat. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
